import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import t from '@instructure/quiz-i18n/format-message';
import { Button } from '@instructure/ui-buttons';
import { TopNavBar } from '@instructure/ui-top-nav-bar';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { IconCalculatorLine } from '@instructure/ui-icons';
import LearnosityCalculator from '../../../LearnosityCalculator';
var CalculatorButton = function CalculatorButton(_ref) {
  var toggleCalculator = _ref.toggleCalculator,
    enabled = _ref.enabled,
    iceTopNavBarEnabled = _ref.iceTopNavBarEnabled;
  if (iceTopNavBarEnabled) {
    return /*#__PURE__*/React.createElement(TopNavBar.Item, {
      id: "CalculatorButton",
      onClick: toggleCalculator,
      variant: "icon",
      renderIcon: /*#__PURE__*/React.createElement(IconCalculatorLine, null),
      disabled: !enabled,
      tooltip: t('This calculator has accessibility limitations.')
    }, t('Calculator'), /*#__PURE__*/React.createElement(ScreenReaderContent, null, t('Use the arrow keys to move the calculator after selecting "Move". Screen readers may not announce the launch clearly.')));
  }
  return /*#__PURE__*/React.createElement(Button, {
    renderIcon: IconCalculatorLine,
    onClick: toggleCalculator,
    disabled: !enabled
  }, /*#__PURE__*/React.createElement(ScreenReaderContent, null, t('Calculator')));
};
CalculatorButton.propTypes = {
  toggleCalculator: PropTypes.func.isRequired,
  enabled: PropTypes.bool.isRequired,
  iceTopNavBarEnabled: PropTypes.bool
};
CalculatorButton.defaultProps = {
  iceTopNavBarEnabled: false
};
export var Calculator = /*#__PURE__*/function (_Component) {
  function Calculator() {
    _classCallCheck(this, Calculator);
    return _callSuper(this, Calculator, arguments);
  }
  _inherits(Calculator, _Component);
  return _createClass(Calculator, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(LearnosityCalculator, Object.assign({}, this.props, {
        render: CalculatorButton
      }));
    }
  }]);
}(Component);
_defineProperty(Calculator, "propTypes", {
  activeCalculatorId: PropTypes.string,
  calculatorType: PropTypes.oneOf(['none', 'basic', 'scientific']),
  quizSessionId: PropTypes.string,
  setActiveCalculatorId: PropTypes.func.isRequired,
  iceTopNavBarEnabled: PropTypes.bool,
  setCalculatorEnabled: PropTypes.func
});
_defineProperty(Calculator, "defaultProps", {
  activeCalculatorId: void 0,
  calculatorType: void 0,
  quizSessionId: void 0,
  iceTopNavBarEnabled: false,
  setCalculatorEnabled: function setCalculatorEnabled() {}
});
export default Calculator;